import { MDBCard, MDBCardBody, MDBCol, MDBRow } from "mdb-react-ui-kit";
import React from "react";
import Layout from "../../components/Layout";
import { useKeycloak } from "../auth/auth.hooks";

export default function DashboardPage({ path }) {
  const { user } = useKeycloak();
  return (
    <Layout path={path}>
      <MDBRow>
        <MDBCol size="12">
          <MDBCard style={{ width: "100%" }}>
            <MDBCardBody>
              <h3>DTA Reports Platform</h3>

              <MDBRow>
                <MDBCol>
                  <p>Hello, {user.name}!</p>
                  <p>This is the DTA Reports platform!</p>
                </MDBCol>
              </MDBRow>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </Layout>
  );
}
